<mat-card>
    <buyiq-empty-state heading="Looks like this page is out of stock"
                       icon="shopping_cart">
    </buyiq-empty-state>
</mat-card>
